import type { SiteConfig } from '../types';

/**
 * Directives archive — brand palette from the live deployment
 * (theme/directives.less: @directives-color-main-1 #02314B, secondary #65a9ce).
 * DOE / energy.gov branding removed.
 */
const directives: SiteConfig = {
  id: 'directives',
  pathPrefix: 'directives',
  baseUrl: 'https://archives.directives.doxcelerate.com',
  title: 'Directives',
  tagline: 'Archive of directives, delegations and policies',
  seoName: 'DOE Directives Archive',
  seoDescription:
    'An independent archive of DOE directives, orders, policies, ' +
    'and delegations. Published by Doxcelerate Corporation — not an ' +
    'official Department of Energy site.',
  colors: {
    primary: '#02314b',
    secondary: '#01212f',
    accent: '#e40101',
  },
  ga4: 'G-CGMCMFW93F',
  nav: [
    { label: 'Home', to: '/' },
    { label: 'Documents', to: '/documents' },
    { label: 'Delegations', to: '/delegations' },
    { label: 'Glossary', to: '/glossary' },
    { label: 'Search', to: '/search' },
    { label: 'About', to: '/about' },
    { label: 'Contact', to: '/contact' },
  ],
  disclaimer:
    'This is an independent archive operated by Doxcelerate Corporation. It is not affiliated with, endorsed by, or operated by the U.S. Department of Energy. Documents are reproduced for reference; where this archive and the official DOE site disagree, the official site is correct.',
  footerGroups: [
    {
      heading: 'Browse',
      links: [
        { label: 'All Documents', to: '/documents' },
        { label: 'Delegations', to: '/delegations' },
        { label: 'Glossary', to: '/glossary' },
        { label: 'Search', to: '/search' },
      ],
    },
    {
      // Cross-links between the archives + the corporate site. These are
      // the only inbound links the sister archives have - keep them.
      heading: 'More from Doxcelerate',
      links: [
        { label: 'DOE Technical Standards Archive', to: 'https://archives.standards.doxcelerate.com/', external: true },
        { label: 'NNSA Policies & Directives Archive', to: 'https://archives.nnsa.doxcelerate.com/', external: true },
        { label: 'Doxcelerate Corporation', to: 'https://www.doxcelerate.com/', external: true },
      ],
    },
  ],
  // Paste the token from each console here to verify this hostname.
  // null emits no tag; an empty string would emit a FAILED verification.
  verification: {
    google: null,
    bing: null,
  },
};

export default directives;
